import reduxFetch from 'react-redux-fetch';
import apiRoutes from '../../../app/api/routes';
import { APP_INSTALLATION_RESOURCE, REMOVE_ROLE_RESOURCE } from '../constants';
import { createErrorMessage } from '../../app/helpers/createErrorMessage';

const RemoveRoleService = ComposedComponent =>
  reduxFetch([
    {
      resource: REMOVE_ROLE_RESOURCE,
      method: 'delete',
      request: (appId, installationId, featureId, roleId, callback, appInstallation = {}, t) => ({
        url: apiRoutes.roleDetail(appId, installationId, featureId, roleId),
        meta: {
          roleId,
          callback,
          setOther: {
            resource: APP_INSTALLATION_RESOURCE,
            values: {
              ...appInstallation,
              appInstallationFeatures: appInstallation.appInstallationFeatures?.map(f => ({
                ...f,
                appInstallationFeatureRoles: f.appInstallationFeatureRoles?.filter(
                  r => r.id !== roleId
                ),
              })),
            },
          },
          toaster: {
            onErrorMessage: createErrorMessage(t, 'removeRoleFailed'),
            onSuccessMessage: t('removeRoleSuccess'),
          },
        },
      }),
    },
  ])(ComposedComponent);

export default RemoveRoleService;
